import classnames from 'classnames';
import { RequiredMarkProps } from './types';
import s from './index.module.scss';

export const RequiredMark = ({ hasError = false, className }: RequiredMarkProps) => (
  <span aria-hidden className={classnames(s.mark, hasError && s.mark_error, className)}>
    *
  </span>
);
